// USAGE
// import CodeMirror from 'codemirror';
// import { codeMirrorConfig } from 'formml';
// CodeMirror.defineSimpleMode('formml', codeMirrorConfig);

export const codeMirrorConfig = {
  // The start state contains the rules that are intially used
  start: [
    // You can match multiple tokens at once. Note that the captured
    // groups must span the whole string in this case
    // {regex: /(function)(\s+)([a-z$][\w$]*)/,
    //  token: ["keyword", null, "variable-2"]},
    // Rules are matched in the order in which they appear, so there is
    // no ambiguity between this one and the one above
    { regex: /(\:)(email|phone|input|textarea)\b/, token: ['operator', 'keyword'] },
  ],
  comment: [
    { regex: /.*?\*\//, token: 'comment', next: 'start' },
    { regex: /.*/, token: 'comment' },
  ],
  meta: {
    dontIndentStates: ['comment'],
    lineComment: '//',
  },
};
